import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import MyTheme from './styles/MyTheme';
import { ThemeProvider } from '@material-ui/styles';


import Login from "./routes/Login"
import Accueil from "./routes/Accueil"
import PrivateRoute from "./routes/PrivateRoute";
import AdminEtudiants from "./routes/AdminEtudiants";
import AdminQuestions from "./routes/AdminQuestions";
import AdminClassements from "./routes/AdminClassements";
import AdminGroupes from "./routes/AdminGroupes";
import AdminStatistiquesApp from "./routes/AdminStatistiquesApp";
import AdminStatistiquesJeux from "./routes/AdminStatistiquesJeux";

export default function App() {

    const [userConnected,setUserConnected]=useState(null)
     

    const handleLogin=(value)=>{
        console.log(value)
        setUserConnected(value)
    }

    const handleDisconnectApp=()=>{
      setUserConnected(null)
    }
    useEffect(()=>{
        console.log(userConnected)
    },[userConnected])



    


  return (
    <ThemeProvider theme={MyTheme}>
    
    <Router>
      {/* <div style={{
          position:"absolute",
          top:250,
          zIndex:50
          }}>
        <nav>
          <ul>
            <li>
              <Link to="/tact">Interface Tact</Link>
            </li>
            <li>
              <Link to="/inter">Interface Inter</Link>
            </li>
            <li>
              <Link to="/login">Login</Link>
            </li>
          </ul>
        </nav>
        </div> */}
        <Switch>
            <PrivateRoute 
            userConnected={userConnected}
            path="/admin-questions"
            component={AdminQuestions }
          />
           <PrivateRoute 
            path="/admin-etudiants"
            userConnected={userConnected}
            component={AdminEtudiants }
          />
          <PrivateRoute 
            path="/admin-groupes"
            userConnected={userConnected}
            component={AdminGroupes }
          />
          <PrivateRoute 
            path="/admin-classements"
            userConnected={userConnected}
            component={AdminClassements }
          />
          <PrivateRoute 
            path="/admin-statistiques-app"
            userConnected={userConnected}
            component={AdminStatistiquesApp }
          />
          <PrivateRoute 
            path="/admin-statistiques-jeux"
            userConnected={userConnected}
            component={AdminStatistiquesJeux }
          />
          <Route path="/login">
            <Login 
                userConnected={userConnected}
                handleLogin={handleLogin}
                handleDisconnectApp={handleDisconnectApp}
            />
          </Route>

          <Route path="/">
            <Accueil 
            />
          </Route>

          
          
        </Switch>
      
    </Router>
  </ThemeProvider>
    );
}